import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { Button } from "@repo/ui/components/Base/Button";
import { useState } from "react";
import { CheckboxInput } from "@repo/ui/components/Base/CheckboxInput";

export interface PublishConfirmationProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
  itemId: string;
  onConfirm?: (
    itemId: string,
    publishOptions: { sendEmails: boolean }
  ) => void | Promise<void>;
  republish?: boolean;
  pastMeetingWarning?: boolean;
}
export function PublishConfirmation({
  open,
  setOpen,
  itemId,
  onConfirm,
  republish,
  pastMeetingWarning,
}: PublishConfirmationProps) {
  const handleOpenChange = () => setOpen(!open);

  const [loading, setLoading] = useState(false);
  const [sendEmails, setSendEmails] = useState(true);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm?.(itemId, { sendEmails });
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-y-4">
          <p>
            {republish ? (
              <>
                Re-publishing this will release the current version of this
                content to the public and cannot be undone.
                <br />
                Are you sure you want to do this?
              </>
            ) : (
              <>
                Publishing this will release the current version of this content
                to the public and cannot be undone.
                <br />
                Are you sure you want to do this?
              </>
            )}
            {pastMeetingWarning && (
              <>
                <br />
                <br />
                <strong>
                  Warning: This meeting has already passed, and meeting minutes
                  exist for it.
                </strong>
              </>
            )}
          </p>

          <CheckboxInput
            orientation="horizontal"
            disabled={loading}
            checked={sendEmails}
            onCheckedChange={(state) => setSendEmails(!!state)}
            label="Send notification emails to subscribed team members"
          />
        </DialogBody>
        <DialogFooter>
          <Button
            disabled={loading}
            onClick={handleOpenChange}
            variant="destructive"
          >
            Cancel
          </Button>
          <Button disabled={loading} onClick={() => handleConfirm()}>
            {pastMeetingWarning
              ? "Confirm Publish Past Meeting"
              : "Confirm Publish"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
